import React, { useState, useEffect, useContext } from "react";
import { makeStyles } from "@material-ui/styles";
import { AppContext, DispatchContext } from "../AppContext";
import * as actions from "../actions/actions";
import { timeConverter, resolveNotificationMessage } from '../helpers/constants';
import Service from "../services/service";
import { ReactComponent as UserProfileIcon } from '../assets/icons/user-profile.svg';
import { ReactComponent as DeliveryIcon } from '../assets/icons/delivery.svg';
import { ReactComponent as HistoryIcon } from '../assets/icons/history.svg';
import { ReactComponent as MoneyIcon } from '../assets/icons/money.svg';
import { ReactComponent as CreditCardIcon } from '../assets/icons/creditcard.svg';
import { ReactComponent as PayPalIcon } from '../assets/icons/paypal.svg';
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';
import NavigateNextIcon from '@material-ui/icons/NavigateNext';
import AccountCircleIcon from '@material-ui/icons/AccountCircle';
import DeleteIcon from '@material-ui/icons/Delete';
import SettingsIcon from '@material-ui/icons/Settings';
import LockIcon from '@material-ui/icons/Lock';
import { Paper, Box, Typography, Button, Tab, Tabs, AppBar, Dialog, DialogActions, DialogContent, DialogTitle, TextField } from "@material-ui/core";
import IconLabel from './IconLabel';
import DividerLabel from './DividerLabel';
import InvoiceAddressForm from './InvoiceAddressForm';
import OrderList from "./OrderList";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}



export default function SettingsDialog() {

  const useStyles = makeStyles((theme) => ({
    dialogContent: {
      borderTop: "1px solid #eeeeee",
      borderBottom: "1px solid #eeeeee",
      height: "520px",
      width: "850px",
      padding: 0,
    },
    tabContent: {
    },
    paper: {
      padding: 20,
      marginLeft: 50,
      marginRight: 50,
      backgroundColor: '#eeeeee'
    },
    tab: {
      textTransform: "none !important",
    },
    textField: {
      width: "100%",
      marginBottom: theme.spacing(2)
    },
    switch: {
      width: "100%",
      marginBottom: theme.spacing(1)
    },
    slider: {
      width: "100%",
      marginBottom: theme.spacing(1),
      marginLeft: 4
    },


  }));




  const state = useContext(AppContext);
  const s = state.strings;
  const dispatch = useContext(DispatchContext);
  const [user, setUser] = useState({});
  const [changed, setChanged] = useState(false);
  const classes = useStyles();


  const [selectedTab, setSelectedTab] = useState(0);
  // update local user data from state when dialog becomes visible
  useEffect(() => {
    state.ui.profileDialogVisible && setUser(state.user);
  }, [state.ui.profileDialogVisible]);

  const handleChange = (newValue, key) => {
    setUser({ ...user, [key]: newValue });
  }

  useEffect(() => {
    setChanged(!user.changePwd && JSON.stringify(state.user) !== JSON.stringify(user));
  }, [user]);

  const handleClose = () => {
    dispatch(actions.setUI({ profileDialogVisible: false }));
  }

  const handleReset = (newValue, key) => {
    setUser(state.user);
  }

  const handleChangePwd = () => {
    setUser({ ...user, changePwd: true, changePwd1: '12345678', changePwd2: '' });
  }

  const handlePwdChanged = () => {
    Service.updateUserPassword(user.changePwd1).then(res => {
      if (!res.success) {
        dispatch(actions.openToast({ type: "error", message: resolveNotificationMessage(res.errors[0], s.notificationMessage), status: true }));
      } else {
        dispatch(actions.openToast({ type: "success", message: s.notificationMessage.passwordChanged, status: true }));
        setUser(state.user);  // reset user to state to disable save dialog
      }
    });
  }

  const handleDeleteAccount = () => {
    dispatch(actions.openConfirmationDialog({
      title: s.userDialog.deleteAccountTitle,
      text: s.userDialog.deleteAccountText,
      onConfirm: () => handleConfirmDelete(),
      hint: s.userDialog.deleteAccountHint,
      waitingMessage: s.userDialog.deleteAccountWaiting
    }));
  }

  const handleConfirmDelete = () => {
    Service.deleteUser().then(res => {
      dispatch(actions.closeConfirmationDialog());
      if (res.success) {
        Service.getUserInfo().then(getInfoRes => {
          dispatch(actions.setUserDetails(getInfoRes.data));
          dispatch(actions.navigate_to("/login"));
          dispatch(actions.openToast({ type: "success", message: s.notificationMessage.accountDeleted, status: true }));
        });
      } else {
        dispatch(actions.openToast({ type: "error", message: resolveNotificationMessage(res.errors[0], s.notificationMessage), status: true }));
      }
    });
  }


  const handleSubmit = () => {
    Service.updateUser(user).then(res => {
      if (!res.success) {
        dispatch(actions.openToast({ type: "error", message: resolveNotificationMessage(res.errors[0], s.notificationMessage), status: true }));
      } else {
        handleClose();
        Service.getUserInfo().then(res => {
          dispatch(actions.setUserDetails(res.data));
        });
        if (res.message) {
          dispatch(actions.openConfirmationDialog({
            title: s.notificationMessage.approvalStartedTitle,
            hint: s.notificationMessage.accountApprovalStartedHint,
            text: resolveNotificationMessage(res.message, s.notificationMessage) 
          }));
        }
      }
    });
  }

  const handleCreateApiKey = () => {
    Service.createUserCode().then(res => {
      if (res.success) {
        dispatch(actions.setUserDetails({ userCode: res.data.userCode }));
        dispatch(actions.openToast({ message: s.notificationMessage.userCodeCreated }));
      } else {
        dispatch(actions.openToast({ type: "error", message: resolveNotificationMessage(res.errors[0], s.notificationMessage) }));
      }
    });
  }

  const handleSelectedTabChange = (event, newValue) => {
    setSelectedTab(newValue);
  }

  const onRevokeButtonClicked = () => {
    Service.revokeMandate(state.user.mandate.id).then(res => {
      if (res.success) {
        Service.getUserInfo().then(res => {
          dispatch(actions.setUserDetails(res.data));
          dispatch(actions.openToast({ message: s.paymentDialog.mandateRevoked }));
        });
      } else {
        dispatch(actions.openToast({ type: "error", message: resolveNotificationMessage(res.errors[0], s.notificationMessage) }));
      }
    });
  }

  const changePwdEnabled = user.changePwd && user.changePwd1 && (user.changePwd1.length >= 5) && (user.changePwd1 == user.changePwd2);

  return (
    <div>
      <Dialog
        className={classes.root}
        open={state.ui.profileDialogVisible}
        onClose={handleClose}
        aria-labelledby="Profile Dialog"
        aria-describedby="Profile Dialog"
        disableBackdropClick
        maxWidth={false}
      >
        <DialogTitle style={{ color: '#0D4A81' }}>{s.userDialog.userProfile}</DialogTitle>
        <DialogContent className={classes.dialogContent}>
          <AppBar position="static" color="default">
            <Tabs
              className={classes.tabs}
              value={selectedTab}
              onChange={handleSelectedTabChange}
              indicatorColor="primary"
              textColor="primary"
              centered
            >
              <Tab className={classes.tab} label={s.userDialog.userAccount} icon={<UserProfileIcon height={60} width={60} />} />
              <Tab className={classes.tab} label={s.userDialog.billingAddress} icon={<DeliveryIcon height={60} width={60} />} />
              <Tab className={classes.tab} label={s.userDialog.orderHistory} icon={<HistoryIcon height={60} width={60} />} />
              <Tab className={classes.tab} label={s.userDialog.paymentMethods} icon={<MoneyIcon height={50} width={50} />} />


            </Tabs>
          </AppBar>
          <TabPanel value={selectedTab} index={0}>
            <>
              <div style={{ display: "flex", justifyContent: "space-between" }}>
                <div style={{ display: "flex", flexDirection: "column", alignItems: "center", flex: "1 1 auto", width: "50%", marginRight: 16 }}>
                  <DividerLabel label={s.userDialog.credentials} />
                  <AccountCircleIcon color="primary" style={{ fontSize: 60, marginBottom: 16 }} />
                  <Typography>{user.mailRepresentation}</Typography>
                  <Typography paragraph variant="body2" color="secondary">{s.userDialog.customerId.format(user.userId)}</Typography>
                  {user.changePwd ? <>
                    <TextField onFocus={e => { e.target.select() }} autoFocus type="password" style={{ marginTop: 8 }} className={classes.textField} size="small" label={s.userDialog.newPassword}
                      value={user.changePwd1}
                      onChange={(e) => handleChange(e.target.value, "changePwd1")} />
                    <TextField type="password" className={classes.textField} size="small" label={s.userDialog.repeatPassword}
                      value={user.changePwd2}
                      onChange={(e) => handleChange(e.target.value, "changePwd2")}
                    />
                    <Button variant="contained" disabled={!changePwdEnabled} onClick={handlePwdChanged} startIcon={<LockIcon />}>{s.userDialog.changePassword}</Button>
                  </>
                    :
                    <>
                      <Button variant="outlined" color="primary" onClick={handleChangePwd} startIcon={<LockIcon />}>{s.userDialog.changePassword}</Button>
                      <Box mt={4} />
                      <DividerLabel label={s.userDialog.deleteAccount} />
                      <Button onClick={handleDeleteAccount} style={{ borderColor: '#FF0000' }} variant="outlined" startIcon={<DeleteIcon />}>{s.userDialog.deleteAccount}</Button>
                    </>
                  }
                </div>
                <div style={{ display: "flex", flexDirection: "column", alignItems: "center", flex: "1 1 auto", width: "50%", marginLeft: 16 }}>
                  <DividerLabel label={s.userDialog.plagawareLicense} />
                  {user.license && user.license.code ?
                    <IconLabel icon={<InfoOutlinedIcon />} label={s.userDialog.accountLinked} /> :
                    <IconLabel icon={<InfoOutlinedIcon />} label={s.userDialog.enterLicense} />}
                  <TextField disabled={user.license && user.license.adminUserId == user.userId} variant="outlined" style={{ marginTop: 16 }} className={classes.textField} size="small" label={s.userDialog.yourLicenseCode}
                    value={user.license && user.license.code}
                    onChange={(e) => handleChange(e.target.value, "license")}
                  />
                  {/* API key generation works directly on the state rather than on local dialog state, as this will change user attribs as well */}
                  <DividerLabel label={s.userDialog.apiKey} />
                  <IconLabel icon={<InfoOutlinedIcon />} label={s.userDialog.apiKeyHint} />
                  <Box mt={2} />
                  {state.user.userCode ?
                    <TextField variant="outlined" disabled className={classes.textField} size="small" label={s.userDialog.yourApiKey}
                      value={state.user.userCode} />
                    :
                    <Button onClick={handleCreateApiKey} variant="outlined" startIcon={<SettingsIcon />}>{s.userDialog.createApiKey}</Button>}
                </div>
              </div>
            </>
          </TabPanel>
          <TabPanel value={selectedTab} index={1}>
            <div style={{ display: "flex", justifyContent: "center" }}>
              <div style={{ width: 500 }}>
                <InvoiceAddressForm user={user} setUser={setUser} />
              </div>
            </div>
          </TabPanel>
          <TabPanel value={selectedTab} index={2}>
            <div style={{ width: "100%", height: 365, overflow: "auto" }}>
              <OrderList />
            </div>
          </TabPanel>
          <TabPanel value={selectedTab} index={3}>
            <div style={{ width: "100%", height: 365, overflow: "auto" }}>
              {!state.user.mandate && <IconLabel centered label={s.userDialog.noPaymentMethodsSaved} />}
              {state.user.mandate &&
                <>
                  <IconLabel mb={32} label={s.userDialog.mandates} />
                  <Paper elevation={3} className={classes.paper}>
                    <div style={{ display: "flex", alignItems: "center" }}>
                      <div style={{ flex: "0 0 auto", marginRight: 24 }}>
                        {state.user.mandate.method == "paypal" ? <PayPalIcon /> : <CreditCardIcon />}
                      </div>
                      <div style={{ flex: "1 1 auto" }}>
                        <Typography variant="h6">{s.payment[state.user.mandate.method]}</Typography>
                        <Typography>{state.user.mandate.name}</Typography>
                        {state.user.mandate.method == "paypal" ?
                          <>
                            <Typography>{state.user.mandate.paypal}</Typography>
                            <Typography variant="body2" color="secondary">{s.payment.date.format(timeConverter(state.user.mandate.date, null, s.common.dateFormat))}</Typography>
                          </>
                          :
                          <>
                            <Typography>{s.payment.cardNumber.format(state.user.mandate.number)}</Typography>
                            <Typography variant="body2" color="secondary">{s.payment.validUntil.format(timeConverter(state.user.mandate.expiryDate, null, s.common.dateFormat))}</Typography>
                          </>
                        }
                      </div>
                      <div style={{ flex: "0 0 auto" }}>
                        <Button onClick={onRevokeButtonClicked}>{s.paymentDialog.revoke}</Button>
                      </div>
                    </div>
                  </Paper>
                </>
              }

            </div>
          </TabPanel>

        </DialogContent>
        <DialogActions >
          <Button disabled={!changed} onClick={handleReset} variant="outlined" color="primary">
            Reset
          </Button>
          <Button onClick={handleClose} variant="outlined" color="primary">
            Cancel
          </Button>
          <Button disabled={!changed} onClick={handleSubmit} variant="contained" color="primary" endIcon={<NavigateNextIcon />} autoFocus>
            Save
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}